import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import config from "./config";
import { auth } from "../utils/firebase";
import jwt_decode from "jwt-decode";
import { triggerGa } from "./gaUtils";
import { GA_ACTION, GA_CATEGORIES, GA_LABEL } from "./constants";
import { APIS_ENDPOINT } from "./api_constants";

export const baseQuery = fetchBaseQuery({
  baseUrl: config.API.url,
  prepareHeaders: async (headers, { getState, endpoint }) => {
    if (endpoint === "postFirebaseLogin") return;
    const firebaseToken = await auth?.currentUser?.getIdToken();
    const authToken =
      localStorage?.adminToken?.replaceAll('"', "") || firebaseToken;
    authToken && headers.set("Authorization", `Token ${authToken}`);
    return headers;
  },
});

export const getQueryStringWithCreator = (query) => {
  const creator = localStorage.username?.replaceAll('"', "");
  if (creator) {
    let encodedCreator = encodeURIComponent(creator);
    if (query.includes("?")) query += `&creator=${encodedCreator}`;
    else query += `?creator=${encodedCreator}`;
  }
  return query;
};

export const baseQueryWithArgs = async (args, api, extraOptions) => {
  let result = null;
  try {
    const endpoint = api.endpoint;
    const addEventLog = APIS_ENDPOINT[endpoint]?.addTimingLogs;
    if (addEventLog) {
      triggerGa({
        category: GA_CATEGORIES.WEB_VITALS,
        action: GA_ACTION.API_CALL_STARTED,
        label: `${GA_LABEL.API_CALL}_${api.endpoint}`,
        eventValue: Date.now(),
      });
    }
    result = await baseQuery(args, api, extraOptions);
    const status = result?.meta?.response?.status;
    if (
      result?.error &&
      (result?.error?.status === 403 || result?.error?.status === 401)
    ) {
      await firebaseUserStateChange();
      result = await baseQuery(args, api, extraOptions);
    }
    if (addEventLog) {
      triggerGa({
        category: GA_CATEGORIES.WEB_VITALS,
        action: GA_ACTION.API_CALL_END,
        label: `${GA_LABEL.API_CALL}_${api.endpoint}`,
        eventValue: Date.now(),
        label2: status,
      });
    }
    return result;
  } catch (e) {
    return result;
  }
};

const firebaseUserStateChange = async () => {
  try {
    const token = await auth?.currentUser?.getIdToken();
    if (token && localStorage?.firebaseToken) {
      localStorage.setItem("firebaseToken", token);
      let decodedToken = jwt_decode(token);
      const tokenExpiry = decodedToken?.exp;
      localStorage.setItem("firebaseTokenExpiry", tokenExpiry);
      // send token to react native when firebase token changes
      const values = {
        firebaseToken: token || null,
        adminToken: localStorage?.adminToken || null,
      };
      if (typeof window !== "undefined" && window?.ReactNativeWebView) {
        window?.ReactNativeWebView?.postMessage(
          JSON.stringify({ type: "token", payload: values })
        );
      }
    }
  } catch (e) {
    //
  }
};

export const postQueryBodyWithCreator = (body) => {
  const creator = localStorage.username?.replaceAll('"', "");
  if (creator) {
    if (!body.creator) body.creator = creator;
  }
  return body;
};
